import { render, staticRenderFns } from "./CoozzyLinkedinIcon.vue?vue&type=template&id=1b35cbd0&scoped=true"
import script from "./CoozzyLinkedinIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyLinkedinIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyLinkedinIcon.vue?vue&type=style&index=0&id=1b35cbd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b35cbd0",
  null
  
)

export default component.exports